import React from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { useStore } from "../../../Store";

const InfoContainerPolestar = () => {
  const { casesStore } = useStore();
  const { t } = useTranslation();
  const phone = casesStore.presentation?.contactPhone;
  if (!casesStore.latestEvent || !phone) return <div id="info-container-polestar" />;

  return (
    <div id="info-container-polestar">
      <div className="assistance-text-polestar">{t("PolestarContactHeader")}</div>
      <a href={`tel:${phone}`}>
        <div id="info-container-info-polestar">
          <div id="info-container-polestar-text">{t("ContactTextPolestar")}</div>
          <div id="info-polestar-logo" />
        </div>
      </a>
    </div>
  );
};

export default observer(InfoContainerPolestar);
